import useServiceStatus from "../../hooks/useServiceStatus";
import { useState } from "react";
import TradeModal from "./TradeModal";
import styles from "../../styles/shared/trade-form/TradeModal.module.css";
import MiniAppTradeModal from "../../components/mini-app/mini-trade/MiniAppTradeModal";

// the mode prop specify the structure of form
// the data prop specify the required data if the mod is not equal to "trade-btn"

function TradeButton({
  btnClassName = "",
  service,
  children,
  data,
  mode,
  defaultStyle = false,
  style = {},
  onClick,
  disabled = false,
}) {
  const [showTradeModal, setShowTradeModal] = useState(false);
  const [showMiniTradeModal, setShowMiniTradeModal] = useState(false);

  const { isActive } = useServiceStatus(service);

  const clickHandler = (e) => {
    if (disabled) {
      e.stopPropagation();
      return;
    }
    if (localStorage.getItem("auth") === "telegram") {
      return setShowMiniTradeModal(true);
    }
    e.stopPropagation();
    if (onClick) {
      onClick();
    }
    //   if the place of button related to a certain service and the service is not active, disabled trade functionality and show the service activation modal
    if (service && !isActive) {
      return console.log("disabled");
    }

    setShowTradeModal(true);
  };

  return (
    <>
      <div
        onClick={clickHandler}
        className={`${defaultStyle ? styles.mainBtn : ""}${btnClassName}`}
        aria-disabled={disabled || undefined}
        style={{
          cursor: disabled ? "not-allowed" : "pointer",
          opacity: disabled ? 0.55 : undefined,
          ...style,
        }}
      >
        {children}
      </div>

      {showMiniTradeModal && (
        <MiniAppTradeModal
          open={showMiniTradeModal}
          closeModal={() => setShowMiniTradeModal(false)}
          coin={data?.coin}
        />
      )}

      {showTradeModal && (
        <TradeModal
          show={showTradeModal}
          setShow={setShowTradeModal}
          mode={mode}
          data={data}
        />
      )}
    </>
  );
}

export default TradeButton;
